import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const presidentRegistretion = createAsyncThunk(
  "presidentRegistretion",
  async (data) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");
      const response = await AxiosInstance.post(`${API_KEY}/api/president/add`, data, {
        headers: { Authorization: "Barear" + token },
        "Content-Type": "application/json",
      });

      return response;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);

const initialState = {
  isLoading: false,
  presidentRegistretionData: null,
  isError: false,
  errorMessage: "",
};
const presidentRegistretionSlice = createSlice({
  name: "presidentRegistretion",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(presidentRegistretion.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(presidentRegistretion.fulfilled, (state, action) => {
      state.isLoading = false;
      state.presidentRegistretionData = action.payload;
    });
    builder.addCase(presidentRegistretion.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default presidentRegistretionSlice.reducer;
